import { render, staticRenderFns } from "./test.vue?vue&type=template&id=b83dad86&scoped=true&"
import script from "./test.vue?vue&type=script&lang=ts&"
export * from "./test.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83dad86",
  null
  
)

export default component.exports